<template>
  <section class="what_oskelly">
    <div class="osk-wrapper">
      <div class="flex_block">
        <div class="left_text">
          <div class="title_block_sm">
            {{ $t('components.info.whatIsOskelly.title') }}
          </div>

          <p>
            {{ $t('components.info.whatIsOskelly.text1') }}
            <br>
            {{ $t('components.info.whatIsOskelly.text2') }}
          </p>
        </div>

        <div class="right_img">
          <img src="~assets/img/info/what-is-oskelly.webp">
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
section.what_oskelly {
  padding: 78px 0 115px;
}

section.what_oskelly .flex_block {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #F2F2F2;
  border-radius: 2px;
  padding: 44px 53px;
}

section.what_oskelly .flex_block .left_text {
  width: 500px;
  max-width: calc(100% - 420px);
}

section.what_oskelly .flex_block .left_text p {
  font-size: 16px;
  line-height: 24px;
  margin-top: 9px;
}

section.what_oskelly .flex_block .right_img {
  width: 400px;
  height: 265px;
}

section.what_oskelly .flex_block .right_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media only screen and (max-width: 1024px) {
  section.what_oskelly {
    padding: 59px 0 60px;
  }

  section.what_oskelly .flex_block {
    padding: 57px 27px;
  }

  section.what_oskelly .flex_block .left_text {
    width: 50%;
    max-width: 100%;
  }

  section.what_oskelly .flex_block .right_img {
    width: 43%;
    height: auto;
  }
}

@media only screen and (max-width: 767px) {
  section.what_oskelly {
    padding: 40px 0 40px;
  }

  section.what_oskelly .flex_block {
    display: block;
    padding: 19px 10px;
  }

  section.what_oskelly .flex_block .left_text {
    width: 100%;
  }

  section.what_oskelly .flex_block .left_text .title_block_sm {
    font-size: 18px;
    line-height: 24px;
  }

  section.what_oskelly .flex_block .left_text p {
    font-size: 14px;
    line-height: 21px;
    margin-top: 6px;
  }

  section.what_oskelly .flex_block .right_img {
    display: none;
  }
}
</style>
